import "./question.scss";
import { getModalByName } from "../../components/modal/index";


(function() {
    const page = document.querySelector('.question-page');

    if (!page) {
        return;
    }

    const dataCurrentUser = page.getAttribute('data-current-user');
    const testElementBox = page.querySelector('.question-page__test');
    let currentPageUID;
    let currentQuestionID;

    page.querySelector('.question-page__list').addEventListener('click', event => {
        if (!dataCurrentUser) {
            return getModalByName('auth').show();
        }

        const item = event.target.closest('.question-page__item');

        if (item) {
            currentPageUID = item.getAttribute('data-id');
            runTest();
        }
    });

    testElementBox.addEventListener('click', event => {
        if (event.target.matches('.send-option')) {
            clickButtonSendOption();
        }

        if (event.target.matches('.reload-view')) {
            runTest();
        }
    });

    function runTest() {
        if (!currentPageUID) {
            return;
        }
        fetch('/api/question/?page='+currentPageUID).then(response => response.json()).then(onResponseGet);
    }
    
    
    function onResponseGet(response) {
        if (response.success) {
            page.classList.add('_view-test');
            currentQuestionID = response.question.id;
            testElementBox.innerHTML = createViewQuestion(response.question);
        }
    }


    function clickButtonSendOption() {
        if (!testElementBox.querySelectorAll(':checked').length) {
            alert("Выберите вариант");
        }

        if (!currentPageUID) {
            return;
        }
    
        const data = JSON.stringify({
            id: currentQuestionID,
            page: currentPageUID,
            answers: Array.from(testElementBox.querySelectorAll('input')).map(item => item.checked)
        });
        
        sendPost(data).then(response => {
            if (response.success) {
                return onResponseGet(response);
            } else {
                if (response.description) {
                    testElementBox.innerHTML = `
                        <h4>Не верно :(</h4>
                        <p>${response.description}</p>
                        <button class="button reload-view">Далее</button>
                    `;
                } else {
                    testElementBox.classList.add('hidden');
                    testElementBox.innerHTML = '';
                }
            }
        });
    }
})();



function createViewQuestion(question) {
    const answers = [];
    question.answers.forEach(item => {
        let value = item.replace(/</g, "&#x3C;");
        value = value.replace(/>/g, "&#x3E;");

        answers.push(`
            <label class="question__option">
                <input type="checkbox"/> ${value}
            </label>
        `);
    });

    let codeBlock = '';

    if (question.block_code) {
        let code = question.block_code;
        if (hljs.listLanguages().includes(question.block_code_type)) {
            code = hljs.highlightAuto(question.block_code).value;
        }
        codeBlock = `<pre><code>${code}</code></pre>`;
    }

    return `
        <div>${question.question}</div> 
        
        ${codeBlock}
        ${answers.join('')}

        <div class="question__footer">
            <button class="button send-option">Ответить</button>
        </div>
    `;
}


function sendPost(data) {
    return fetch('/api/question/', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        body: data
    }).then(response => response.json());
}